/*eslint-disable */
import {bus} from '@/main';
export default {
  name: 'data-instruction-popup',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    closeDatasetInstructionPopupMethod(){
      bus.$emit('dataInstructionPopupStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
    openUploadDataPopupMethod(){
      bus.$emit('dataInstructionPopupStateBus', false)
      bus.$emit('createAlgoDataPopupBus', true)
    }
  }
}